import { DeleteIcon } from '@chakra-ui/icons'
import { HStack, IconButton, Image, Spinner, Text, VStack } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useRemoveCartItem } from 'src/services/api/queries/queries'
import { CartItem } from 'src/types/types'
import { formatPrice } from 'src/utils/cart'

export interface CartListItemProps {
  item: CartItem
}

const euro = Intl.NumberFormat('fi-FI', {
  style: 'currency',
  currency: 'EUR',
})

const CartListItem: FC<CartListItemProps> = ({ item }) => {
  const { mutate: removeItem, isLoading } = useRemoveCartItem()
  const { key, id, images, name, prices } = item

  const handleRemoveItem = () => {
    removeItem(key)
  }

  return (
    <HStack
      justifyContent='space-between'
      p={4}
      shadow='md'
      borderWidth={1}
      borderRadius='md'
      key={id}
      backgroundColor='white'
      width='100%'
    >
      <HStack alignItems='center' spacing={4}>
        <Image width='100px' src={images?.[0]?.src} alt={name} />
        <VStack align='start' spacing={1}>
          <Text>{name}</Text>
          <Text>
            {prices?.sale_price &&
              formatPrice(prices.sale_price, prices.currency_symbol, prices.currency_minor_unit)}
          </Text>
        </VStack>
      </HStack>
      {isLoading ? (
        <Spinner />
      ) : (
        <IconButton
          aria-label='Remove from cart'
          icon={<DeleteIcon />}
          variant='outline'
          colorScheme='red'
          onClick={handleRemoveItem}
        />
      )}
    </HStack>
  )
}

export default CartListItem
